import React from "react";
import { Fade } from "react-awesome-reveal";
import { ArrowDownOutlined } from "@ant-design/icons";
import { Button } from "antd";
import mobileImg from "../../assets/team_03.jpg";
import "./styles.scss";

const HoemMobileGamesDevelop = () => {
  return (
    <section className="home-mobile-game-section">
      <div className="section-title-text">We develop mobile games</div>
      <div className="section-title-desc">
        Games that hundreds of players all over the world loved to play
      </div>
      <img src={mobileImg} alt="#" className="mobile-img" />
      <Fade direction="bottom-right">
        <div className="info-text">
          <span className="main-text">ShiftedPixel</span> is a small Canadian
          company founded by two friends to develop the most enjoyable games in
          the world. Focusing on mobile market they brought to life such titles
          as Police Pursuit. Simple, innovative gameplay and unlimited fun is
          their motto.
        </div>
      </Fade>

      <Button
        className="more-games-btn"
        icon={<ArrowDownOutlined />}
        iconPosition="end"
        href="/about-us"
      >
        Read our story
      </Button>
    </section>
  );
};

export default HoemMobileGamesDevelop;
